import axios from 'axios'
import { axiosInterceptors } from '@accor/customer-core'
import { env } from '@accor/customer-core/env'

const axiosAem = axios.create({})

axiosInterceptors.urlInterceptor(axiosAem, env.generateGetter('apiAem'))

export default axiosAem
